import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldDictionaryValue = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.dictionary_value_id,
    code: item?.dictionary_value_code,
    value: item?.dictionary_value_name,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
    isSignificant: item?.is_significant,
  }
}

export const getDictionaryValueListApi = ({ dictionary_id, param, is_active, page, size }) => {
  const params = removeEmpty({
    param,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: `/api/v1/dictionary_value/${dictionary_id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldDictionaryValue),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createDictionaryValueApi = ({
  dictionary_id,
  dictionary_value_code,
  dictionary_value_name,
  is_significant,
  is_active,
}) => {
  const data = {
    dictionary_id,
    dictionary_value_code,
    dictionary_value_name,
    is_significant,
    is_active,
  }

  const config = {
    method: 'post',
    url: '/api/v1/dictionary_value/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getDictionaryValueByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/dictionary_value/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: mapFieldDictionaryValue(res.data?.[0]) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteDictionaryValueByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/dictionary_value/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateDictionaryValueByIdApi = ({
  id,
  dictionary_id,
  dictionary_value_code,
  dictionary_value_name,
  is_significant,
  is_active,
}) => {
  const data = {
    dictionary_id,
    dictionary_value_code,
    dictionary_value_name,
    is_significant,
    is_active,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/dictionary_value/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
